import { createContext, useContext, useState } from 'react';
import { AnyJsx, Language } from '../../assets/ts/customTypes';
import { de } from '../../assets/languages/de';
import { en } from '../../assets/languages/en';
import { fr } from '../../assets/languages/fr';
import { es } from '../../assets/languages/es';
import { it } from '../../assets/languages/it';
import { nl } from '../../assets/languages/nl';

export type LanguageContextType = [Language, (language: Language) => void];

export const LanguageContext = createContext<LanguageContextType>(null as any);

export function useLanguage() {
    const val = useContext(LanguageContext);
    if (!val) {
        throw new Error('LanguageContext not found');
    }

    return val;
}

function getDefaultLanguage() {
    const language = new URLSearchParams(window.location.search).get('language');
    switch (language) {
        case 'de':
            return de;
        case 'en':
            return en;
        case 'fr':
            return fr;
        case 'es':
            return es;
        case 'it':
            return it;
        case 'nl':
            return nl;
        default:
            return en;
    }
}

export function LanguageContextProvider(props: {children: AnyJsx}) {
    const state = useState(getDefaultLanguage());

    return <LanguageContext.Provider value={state}>{props.children}</LanguageContext.Provider>;
}
